// extracted by mini-css-extract-plugin
export default {"media":"MediaBlock-module--media--8df2f","figure":"MediaBlock-module--figure--dc486","outer":"MediaBlock-module--outer--c7e62","halfWidth":"MediaBlock-module--halfWidth--dde98"};